import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { chatMessageSent } from '../../store/offer_chats';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { HomeownerBlock, IHomeownerBlockProps } from './HomeownerBlock';
import { isDealRent } from '../../selectors/isDealRent';
import { isDealRentCianAgency } from '../../utils/dealRentCianAgencyExperiment';

export type THomeownerBlockContainerState = Pick<
  IHomeownerBlockProps,
  | 'abGroup'
  | 'agent'
  | 'offer'
  | 'user'
  | 'offerChat'
  | 'isAuthenticated'
  | 'isOfferOwnedByUser'
  | 'isAgentAvailable'
  | 'isDealRentCianAgencyEnabled'
>;

export type THomeownerBlockContainerDispatch = Pick<IHomeownerBlockProps, 'setPhoneCollapse' | 'chatMessageSent'>;

export const mapStateToProps = (state: IState): THomeownerBlockContainerState => {
  const {
    abGroup,
    offerData: { agent, agentAvailability, offer, user },
    offerChat,
  } = state;

  return {
    abGroup,
    agent,
    offer,
    user,
    offerChat,
    isAuthenticated: !!(user && user.isAuthenticated),
    isOfferOwnedByUser: !!(user && user.isAuthenticated && user.realtyUserId === offer.userId),
    isAgentAvailable: !!(agentAvailability && agentAvailability.available),
    isDealRentCianAgencyEnabled: Boolean(isDealRent(state) && isDealRentCianAgency(state.abUseExperiments)),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>): THomeownerBlockContainerDispatch => ({
  chatMessageSent: () => dispatch(chatMessageSent()),
  setPhoneCollapse: () => dispatch(setPhoneCollapse()),
});

export const HomeownerBlockContainer = connect(mapStateToProps, mapDispatchToProps)(HomeownerBlock);
